export var AdsManagerEventKey;
(function (AdsManagerEventKey) {
    // AD_BREAK_FETCH_ERROR = 'AD_BREAK_FETCH_ERROR',
    // AD_BREAK_READY = 'AD_BREAK_READY',
    // AD_BUFFERING = 'AD_BUFFERING',
    // AD_CAN_PLAY = 'AD_CAN_PLAY',
    AdsManagerEventKey["AD_METADATA"] = "AD_METADATA";
    AdsManagerEventKey["AD_PROGRESS"] = "AD_PROGRESS";
    AdsManagerEventKey["ALL_ADS_COMPLETED"] = "ALL_ADS_COMPLETED";
    AdsManagerEventKey["CLICK"] = "CLICK";
    AdsManagerEventKey["COMPLETE"] = "COMPLETE";
    AdsManagerEventKey["CONTENT_PAUSE_REQUESTED"] = "contentPauseRequested";
    AdsManagerEventKey["CONTENT_RESUME_REQUESTED"] = "contentResumeRequested";
    // DURATION_CHANGE = 'durationChange',
    AdsManagerEventKey["FIRST_QUARTILE"] = "FIRST_QUARTILE";
    // IMPRESSION = 'impression',
    // INTERACTION = 'interaction',
    // LINEAR_CHANGED = 'linearChanged',
    AdsManagerEventKey["LOADED"] = "LOADED";
    // LOG = 'log',
    AdsManagerEventKey["MIDPOINT"] = "MIDPOINT";
    AdsManagerEventKey["PAUSED"] = "PAUSED";
    AdsManagerEventKey["RESUMED"] = "RESUMED";
    // SKIPPABLE_STATE_CHANGED = 'skippableStateChanged',
    AdsManagerEventKey["SKIPPED"] = "SKIPPED";
    AdsManagerEventKey["STARTED"] = "STARTED";
    AdsManagerEventKey["THIRD_QUARTILE"] = "thirdquartile";
    // USER_CLOSE = 'userClose',
    // VIDEO_CLICKED = 'videoClicked',
    // VIDEO_ICON_CLICKED = 'videoIconClicked',
    // VOLUME_CHANGED = 'volumeChanged',
    // VOLUME_MUTED = 'volumeMuted',
})(AdsManagerEventKey || (AdsManagerEventKey = {}));
export class AdsManager {
    listeners = new Map();
    addEventListener(eventKey, listener) {
        if (!this.listeners.has(eventKey)) {
            this.listeners.set(eventKey, []);
        }
        this.listeners.get(eventKey)?.push(listener);
    }
    removeEventListener(eventKey, listener) {
        const eventListeners = this.listeners.get(eventKey);
        if (!eventListeners) {
            return;
        }
        this.listeners.set(eventKey, eventListeners.filter((l) => l !== listener));
    }
    dispatch(key, data) {
        const handler = this.listeners.get(key);
        handler?.forEach((listener) => listener(data));
    }
    // @ts-expect-error unused
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    loadAds(ads) {
        // empty
    }
    // @ts-expect-error unused
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    resize(width, height) {
        // empty
    }
    // @ts-expect-error unused
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setVolume(volume) {
        // empty
    }
    pause() {
        // empty
    }
    resume() {
        // empty
    }
    destroy() {
        // empty
    }
    stop() {
        // empty
    }
}
